(function () {
if (window.__sspInit) return;
window.__sspInit = true;
var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
var money = function (c) { return BRL.format(c / 100); };
var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
function imgUrl(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function initBox(box) {
var raw = box.querySelector('[data-ssp-product]');
if (!raw) return;
var p;
try { p = JSON.parse(raw.textContent); } catch (e) { return; }
var form = box.querySelector('form');
var idInput = box.querySelector('[data-ssp-id]');
var btn = box.querySelector('[data-ssp-buy]');
var $ = function (s) { return box.querySelector(s); };
var sizes = [], kitVals = [];
p.variants.forEach(function (v) {
if (sizes.indexOf(v.option1) < 0) sizes.push(v.option1);
if (kitVals.indexOf(v.option2) < 0) kitVals.push(v.option2);
});
var kits = kitVals.map(function (v) {
var m = /^\s*(\d+)/.exec(v), t = /\(([^)]+)\)/.exec(v);
var tag = t ? t[1].replace(/^\s+|\s+$/g, '') : '';
if (/^individual$/i.test(tag)) tag = '';
return { value: v, n: m ? parseInt(m[1], 10) : 1, tag: tag };
}).sort(function (a, b) { return a.n - b.n; });
var state = { size: null, kit: (kits.filter(function (k) { return /mais vendido/i.test(k.tag); })[0] || kits[0]).value };
function variant(size, kit) {
var s = size || sizes[0];
return p.variants.filter(function (v) { return v.option1 === s && v.option2 === kit; })[0];
}
var single = (function () {
var one = kits.filter(function (k) { return k.n === 1; })[0];
var v = one && variant(null, one.value);
return v ? v.price : null;
})();
/* selectors */
$('[data-ssp-sizes]').innerHTML = sizes.map(function (s, i) {
return '<div class="ssp-opt"><input type="radio" name="ssp-size-' + p.id + '" id="ssp-s' + i + '-' + p.id + '" value="' + esc(s) + '"><label class="ssp-size" for="ssp-s' + i + '-' + p.id + '">' + esc(s) + '</label></div>';
}).join('');
$('[data-ssp-kits]').innerHTML = kits.map(function (k, i) {
var tagCls = /melhor/i.test(k.tag) ? ' ssp-kit__tag--b' : '';
return '<div class="ssp-opt"><input type="radio" name="ssp-kit-' + p.id + '" id="ssp-k' + i + '-' + p.id + '" value="' + esc(k.value) + '"' + (k.value === state.kit ? ' checked' : '') + '>' +
'<label class="ssp-kit" for="ssp-k' + i + '-' + p.id + '">' + (k.tag ? '<span class="ssp-kit__tag' + tagCls + '">' + esc(k.tag) + '</span>' : '') +
'<span><span class="ssp-kit__n">' + k.n + (k.n > 1 ? ' pares' : ' par') + '</span><span class="ssp-kit__sub" data-ssp-sub="' + i + '"></span></span>' +
'<span class="ssp-kit__tot" data-ssp-tot="' + i + '"></span></label></div>';
}).join('');
function render() {
var cur = variant(state.size, state.kit);
var k = kits.filter(function (x) { return x.value === state.kit; })[0];
kits.forEach(function (kk, i) {
var v = variant(state.size, kk.value); if (!v) return;
$('[data-ssp-tot="' + i + '"]').textContent = money(v.price);
var per = kk.n > 1 ? money(Math.round(v.price / kk.n)) + ' por par' : 'Compra avulsa';
var save = single && kk.n > 1 ? single * kk.n - v.price : 0;
$('[data-ssp-sub="' + i + '"]').innerHTML = esc(per) + (save > 0 ? '<span class="ssp-kit__save">Economize ' + money(save) + '</span>' : '');
});
if (!cur) return;
idInput.value = cur.id;
$('[data-ssp-price]').textContent = money(cur.price);
$('[data-ssp-per]').textContent = k.n > 1 ? money(Math.round(cur.price / k.n)) + ' por par' : '';
var save = single && k.n > 1 ? single * k.n - cur.price : 0;
$('[data-ssp-save]').textContent = save > 0 ? 'Economize ' + money(save) : '';
btn.disabled = !cur.available;
btn.querySelector('span').textContent = cur.available ? 'Comprar agora' : 'Indisponível';
var label = k.n + (k.n > 1 ? ' pares' : ' par') + (state.size ? ', nº ' + state.size : '');
document.querySelectorAll('[data-ssp-bar-l]').forEach(function (n) { n.textContent = label; });
document.querySelectorAll('[data-ssp-bar-p]').forEach(function (n) { n.textContent = money(cur.price); });
}
box.addEventListener('change', function (e) {
var t = e.target;
if (t.name === 'ssp-size-' + p.id) { state.size = t.value; box.classList.remove('ssp-need'); }
if (t.name === 'ssp-kit-' + p.id) { state.kit = t.value; }
render();
});
function needSize() {
box.classList.add('ssp-need');
var first = box.querySelector('[data-ssp-sizes] input');
var target = box.querySelector('[data-ssp-sizes]');
var top = target.getBoundingClientRect().top + window.pageYOffset - 140;
window.scrollTo({ top: top, behavior: 'smooth' });
if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
}
/* compra direta: limpa o carrinho e abre o checkout pelo link de compra do Shopify */
window.sspNavigate = window.sspNavigate || function (u) { window.location.href = u; };
function buy() {
if (!state.size) { needSize(); return; }
var cur = variant(state.size, state.kit);
if (!cur || !cur.available || btn.disabled) return;
btn.disabled = true;
btn.querySelector('span').textContent = 'Indo para o pagamento...';
var go = function () { window.sspNavigate('/cart/' + cur.id + ':1'); };
setTimeout(function () { btn.disabled = false; render(); }, 8000);
try { fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(go, go); } catch (e) { go(); }
}
form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); buy(); }, true);
btn.addEventListener('click', function (e) { e.preventDefault(); buy(); });
/* gallery: todas as fotos do produto, inteiras (sem recorte) */
var slides = (p.images || []).map(function (u, i) { return { src: u.replace(/^\/\//, 'https://'), alt: p.title + ', foto ' + (i + 1) }; });
var track = $('[data-ssp-track]');
track.innerHTML = slides.map(function (s, i) {
return '<div class="ssp-slide"><img src="' + imgUrl(s.src, 900) + '" srcset="' + imgUrl(s.src, 600) + ' 600w,' + imgUrl(s.src, 900) + ' 900w,' + imgUrl(s.src, 1200) + ' 1200w" sizes="(min-width:900px) 560px, 100vw" alt="' + esc(s.alt) + '" ' + (i === 0 ? 'fetchpriority="high"' : 'loading="lazy"') + ' width="900" height="900"></div>';
}).join('');
var dots = $('[data-ssp-dots]'), thumbs = $('[data-ssp-thumbs]');
dots.innerHTML = slides.map(function (s, i) { return '<button type="button" class="ssp-dot" aria-label="Foto ' + (i + 1) + '" data-i="' + i + '"></button>'; }).join('');
thumbs.innerHTML = slides.map(function (s, i) { return '<button type="button" class="ssp-thumb" aria-label="Ver foto ' + (i + 1) + '" data-i="' + i + '"><img src="' + imgUrl(s.src, 240) + '" alt="" loading="lazy" width="240" height="240"></button>'; }).join('');
function mark(i) {
[].forEach.call(box.querySelectorAll('.ssp-dot,.ssp-thumb'), function (n) { n.setAttribute('aria-current', String(+n.getAttribute('data-i') === i)); });
}
box.addEventListener('click', function (e) {
var b = e.target.closest('[data-i]');
if (b) track.scrollTo({ left: track.clientWidth * (+b.getAttribute('data-i')), behavior: 'smooth' });
});
var tick = 0;
track.addEventListener('scroll', function () {
cancelAnimationFrame(tick);
tick = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
}, { passive: true });
mark(0);
render();
/* barra fixa (celular) */
var bar = document.querySelector('[data-ssp-bar]');
if (bar) {
var panel = $('[data-ssp-panel]');
var upd = function () {
var r = panel.getBoundingClientRect(), h = window.innerHeight;
var visible = r.top < h * 0.85 && r.bottom > h * 0.15;
bar.classList.toggle('is-on', !visible && window.pageYOffset > 480);
};
window.addEventListener('scroll', upd, { passive: true });
window.addEventListener('resize', upd);
upd();
bar.querySelector('button').addEventListener('click', function () {
if (state.size) { buy(); }
else { var y = box.getBoundingClientRect().top + window.pageYOffset - 60; window.scrollTo({ top: y, behavior: 'smooth' }); setTimeout(needSize, 500); }
});
}
}
function boot() { [].forEach.call(document.querySelectorAll('[data-ssp-buybox]'), initBox); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
